/* eslint-disable @typescript-eslint/no-explicit-any */
import type { GetServerSideProps } from 'next';
import { getServerSession } from 'next-auth/next';

import { loginServerSideProps, LoginRoutingProps, SignIn } from '@edelman/storyblok-ui';
import { nextLoginStatus } from '@edelman/storyblok-ui/src/utils';

import { authOptions } from './api/auth/[...nextauth]';

export const getServerSideProps: GetServerSideProps<LoginRoutingProps, any> = async context => {
  const { req, res } = context;
  // Get processed page props
  const pageProps: any = await loginServerSideProps(context);
  const { rootFolder } = pageProps.props;

  // Check if we're logged in already and get ecrypted session info
  const userSession = await getServerSession(req, res, authOptions);
  const loginStatus = await nextLoginStatus({ context, userSession, rootFolder });

  if (loginStatus?.redirect) return loginStatus;

  return {
    ...pageProps,
    props: {
      ...pageProps.props,
      loggedStatus: loginStatus.loggedStatus,
    },
  };
};

export default SignIn;
